// extracted by mini-css-extract-plugin
export default {"instanceElement":"instanceElement---Pg_Bj"};